export const ERROR_MESSAGES_CONTENT_TOO_LARGE = 'Content is too large'
export const MIN_VALUE = 1
export const MAX_VALUE = 365
